<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_day') }}</p>
    </div>
    <div>
      <hot :useScene="scene" />
    </div>
  </Card>
</template>

<script>
import hot from '../../../components/hot-chart.vue';
export default {
  data() {
    return {
      scene: 'FULL',
    };
  },
  components: {
    hot,
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
</style>
